document.addEventListener('DOMContentLoaded', () => {
  const tabsNav = document.getElementById('tabhNav');
  const tabLinks = [...document.querySelectorAll('.tabh-nav a')];
  const tabContents = [...document.querySelectorAll('.tabh-content')];
  const headerGroup = document.getElementById('header-group');
  const productInformation = document.querySelector('.product-information');

  let tabsOffsetTop = 0;
  let topHeight = 0;
  let ticking = false;

  const updateMeasurements = () => {
    topHeight = (headerGroup?.offsetHeight || 0) + (productInformation?.offsetHeight || 0);
    tabsOffsetTop = tabsNav ? tabsNav.getBoundingClientRect().top + window.scrollY : 0;
  };

  const updateTabs = () => {
    ticking = false;

    if (!tabsNav) return;

    const scrollPosition = window.scrollY;
    tabsNav.classList.toggle('fixed', scrollPosition >= tabsOffsetTop + topHeight);

    let currentTab = '';
    for (const content of tabContents) {
      const contentTop = content.getBoundingClientRect().top + scrollPosition + topHeight;
      const contentBottom = contentTop + content.offsetHeight;

      if (scrollPosition >= contentTop - 100 && scrollPosition < contentBottom - 100) {
        currentTab = content.id;
        break;
      }
    }

    if (!currentTab) return;

    for (const link of tabLinks) {
      link.classList.toggle('active', link.hash === `#${currentTab}`);
    }
  };

  const requestTabsUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateTabs);
  };

  updateMeasurements();
  updateTabs();

  window.addEventListener('scroll', requestTabsUpdate, { passive: true });
  window.addEventListener('resize', () => {
    updateMeasurements();
    requestTabsUpdate();
  }, { passive: true });

  for (const link of tabLinks) {
    link.addEventListener('click', (event) => {
      const target = link.hash ? document.getElementById(link.hash.slice(1)) : null;
      if (!target) return;

      event.preventDefault();
      for (const item of tabLinks) item.classList.remove('active');
      link.classList.add('active');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  for (const id of ['tab-ship', 'tab-faq']) {
    const panel = document.getElementById(id);
    if (panel) panel.style.display = 'block';
  }

  const questions = [...document.querySelectorAll('#accordion-box .item-title')];
  for (const question of questions) {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      if (!answer) return;
      answer.style.maxHeight = answer.style.maxHeight ? '' : `${answer.scrollHeight}px`;
    });
  }

  const firstAnswer = questions[0]?.nextElementSibling;
  if (firstAnswer) firstAnswer.style.maxHeight = `${firstAnswer.scrollHeight}px`;

  const sideMenu = document.getElementById('product-side-menu');
  if (sideMenu) {
    fetch(`${Shopify.routes.root}?view=sidebarcategories`)
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
        return response.text();
      })
      .then((html) => {
        sideMenu.innerHTML = html;
      })
      .catch((error) => {
        console.warn('Unable to load the product side menu.', error);
      });
  }
});

window.addEventListener('load', () => {
  const container = document.getElementById('video-iframe');
  const src = container?.dataset.vurl;

  if (!container || !src || container.querySelector('iframe')) return;

  const iframe = document.createElement('iframe');
  iframe.src = src;
  iframe.width = '100%';
  iframe.height = '480';
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '');
  iframe.loading = 'lazy';
  iframe.title = container.dataset.title || 'Product video';
  container.appendChild(iframe);
});


/*document.addEventListener('DOMContentLoaded', function() {
const tabsNav = document.getElementById('tabhNav');
const tabLinks = document.querySelectorAll('.tabh-nav a');
const tabContents = document.querySelectorAll('.tabh-content');
const offsetTop = tabsNav.offsetTop;
let topHeight=document.querySelector('#header-group').offsetHeight + document.querySelector('.product-information').offsetHeight;
   
// 监听滚动事件
window.addEventListener('scroll', function() {
    // 固定tabs导航栏
    if (window.pageYOffset >= offsetTop+topHeight) {
        tabsNav.classList.add('fixed');
    } else {
        tabsNav.classList.remove('fixed');
    }
    
    // 高亮当前可见的tab
    let currentTab = '';
    tabContents.forEach(content => {
        const contentTop = content.offsetTop+topHeight;
        const contentHeight = content.offsetHeight;        
        if (window.pageYOffset >= contentTop - 100 && 
            window.pageYOffset < contentTop + contentHeight - 100) {
            currentTab = content.id;
        }
    });
    
    if (currentTab) {
        tabLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href') === `#${currentTab}`) {
                link.classList.add('active');
            }
        });
    }
});

// 点击切换tab并滚动到对应内容
    tabLinks.forEach(link => {
      link.addEventListener('click', () => {
        tabLinks.forEach(i => i.classList.remove('active'));
        link.classList.add('active');
        const targetId = link.getAttribute('href');
        document.querySelector(targetId).scrollIntoView({ behavior: 'smooth' });
      });
    });  
   document.getElementById('tab-ship').style.display = 'block';document.getElementById('tab-faq').style.display = 'block';

//FAQ accordion 
      const qs = document.querySelectorAll('#accordion-box .item-title');
      qs.forEach(q => {
        q.addEventListener('click', () => {
          const a = q.nextElementSibling;
          if (a.style.maxHeight) {
            a.style.maxHeight = null;
          } else {
            a.style.maxHeight = a.scrollHeight + 'px';
          }
        });
      });
      if (qs.length > 0) {
        const i = qs[0].nextElementSibling;
        i.style.maxHeight = i.scrollHeight + 'px';
      }

  const getSideMenu = async() => {
    const response = await fetch(Shopify.routes.root+'?view=sidebarcategories');
    const data = await response.text()
    document.getElementById('product-side-menu').innerHTML=data;
  }
  getSideMenu();

});

window.addEventListener('load', function() {
  function loadIframe(width,height) {
  let e=document.getElementById('video-iframe');
  if(e){
    let src = e.dataset.vurl;
    let i = document.createElement('iframe');i.src = src;i.width = width;i.height = height;i.frameborder=0;i.allowfullscreen;  
     if (!document.querySelector(`iframe[src="${src}"]`)) {       
        e.appendChild(i);
    }   
 }
}
loadIframe('100%','480');
});
*/